import CryptoJS from 'crypto-js';

export class CryptoHelper {
  private static secretKey = process.env.REACT_APP_ENCRYPTION_KEY!;
  private static key = CryptoJS.enc.Utf8.parse(CryptoHelper.secretKey.padEnd(32, '0').slice(0, 32));

  static encryptData(data: any): string {
    const dataString = typeof data === 'string' ? data : JSON.stringify(data);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(dataString, CryptoHelper.key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return `${CryptoJS.enc.Hex.stringify(iv)}:${encrypted.toString()}`;
  }

  static decryptData(encryptedText: string): string {
    const [ivHex, encryptedData] = encryptedText.split(':');
    if (!ivHex || !encryptedData) throw new Error('Invalid encrypted text format');

    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, CryptoHelper.key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}